import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import GuidedTour from '../Editor/Guide/GuidedTour';
import { steps } from '../Editor/Guide/GuideInterface';
import { useDispatch } from 'react-redux';
import { CANVAS_GUIDE_CURRENT_STEP } from '../../Rutab/RutabConstants';
import Price from '../Editor/Price';
import AddToCart from '../Editor/AddToCart';
const DecalEditorFooter = ({ fabricCanvas, isLoading, }) => {
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [tourSteps, setTourSteps] = useState([]);
    const dispatch = useDispatch();
    const handleHelpClick = () => {
        if (isTourOpen)
            return handleTourIsClosed();
        setIsTourOpen(false);
        setTimeout(() => {
            setTourSteps(steps);
            setIsTourOpen(true);
            const element = document.querySelector('.help-section-guide');
            element.classList.add('tour-highlight-pulse-helper-button');
        }, 50);
    };
    const handleTourIsClosed = () => {
        setIsTourOpen(false);
        const element = document.querySelector('.help-section-guide');
        element.classList.remove('tour-highlight-pulse-helper-button');
        dispatch({
            type: CANVAS_GUIDE_CURRENT_STEP,
            payload: { decalGuide: null },
        });
    };
    const CartSkeleton = () => {
        return (_jsxs("div", { className: "cart-section cart-section--skeleton", children: [_jsx("div", { className: "skeleton skeleton-text skeleton-text--short" }), _jsx("div", { className: "skeleton skeleton-text skeleton-text--price" }), _jsxs("div", { className: "quantity-input", children: [_jsx("div", { className: "skeleton skeleton-text skeleton-text--label" }), _jsx("div", { className: "skeleton skeleton-input" })] }), _jsx("div", { className: "skeleton skeleton-icon" }), _jsxs("div", { className: "button-container", children: [_jsx("div", { className: "skeleton skeleton-button" }), _jsx("div", { className: "skeleton skeleton-button" })] })] }));
    };
    return (_jsxs(_Fragment, { children: [_jsxs("footer", { className: "decal-editor-footer", children: [_jsx("div", { className: "help-section help-section-guide guided-tour-highlight-helper-button", onClick: handleHelpClick, children: _jsx("span", { children: isTourOpen ? 'Stäng guiden' : 'Hjälp' }) }), _jsx("div", { className: "cart-section", children: isLoading ? (_jsx(CartSkeleton, {})) : (_jsxs(_Fragment, { children: [_jsx(Price, { fabricCanvas: fabricCanvas }), _jsx(AddToCart, { fabricCanvas: fabricCanvas })] })) })] }), isTourOpen && (_jsx(GuidedTour, { steps: tourSteps, isOpen: isTourOpen, onClose: handleTourIsClosed, onComplete: handleTourIsClosed }))] }));
};
export default DecalEditorFooter;
